import { createFileRoute } from '@tanstack/react-router';

import { NetworkDetailsPage } from '../features/admin/networks/components/NetworkDetailsPage';
import { dashboardRouteSearchSchema } from '../features/dashboard/dashboardRouteSearch';

export const Route = createFileRoute('/networks/$networkId/details/overview')({
  validateSearch: dashboardRouteSearchSchema,
  component: NetworkOverviewRoute,
});

function NetworkOverviewRoute() {
  const { networkId } = Route.useParams();
  return <NetworkDetailsPage networkId={networkId} />;
}
